import footerBg from "@/assets/footer-bg.jpg";

export function FAQ() {
  return (
    <div className="min-h-screen bg-background">
      <article className="pt-24 md:pt-32 pb-20 mx-auto px-6 max-w-175">
        <h1 className="font-display text-4xl text-foreground text-center mb-12">
          FAQ
        </h1>

        <div className="mb-8">
          <h2 className="font-display font-bold text-foreground mb-3">When is the RSVP deadline?</h2>
          <p className="font-body text-muted-foreground leading-relaxed">Please RSVP by July 15th.</p>
        </div>

        <div className="mb-8">
          <h2 className="font-display font-bold text-foreground mb-3">Do you have a registry?</h2>
          <p className="font-body text-muted-foreground leading-relaxed">
            We won't be having a traditional registry. Instead, we'll be honoring the Chinese tradition of red envelopes (hongbao). If you'd like to give a gift, we'll gratefully accept cash or Venmo.
          </p>
        </div>

        <div className="mb-8">
          <h2 className="font-display font-bold text-foreground mb-3">What is the dress code?</h2>
          <p className="font-body text-muted-foreground leading-relaxed">
            Cocktail attire. Or whatever makes you feel your absolute best. You do you!
          </p>
          <p className="font-body text-muted-foreground leading-relaxed mt-4">
            The wedding venue is outdoors on grass, so skip the stilettos. Hood River can also get very windy and chilly at night, so warm layers are encouraged. We'll keep an eye on the forecast and give a heads up if anything unexpected pops up.
          </p>
        </div>

        <div className="mb-8">
          <h2 className="font-display font-bold text-foreground mb-3">Can I bring a +1?</h2>
          <p className="font-body text-muted-foreground leading-relaxed">
            Due to limited space, we're only able to accommodate guests listed on the invitation. If your invitation includes a guest, they'll be named there. Thank you so much for understanding!
          </p>
        </div>

        <div className="mb-8">
          <h2 className="font-display font-bold text-foreground mb-3">Are kids welcome?</h2>
          <p className="font-body text-muted-foreground leading-relaxed">
            As much as we love your little ones, we will not be including them in the ceremony or reception. However, we recognize that some of you will be traveling with your kids, so please know they are welcome at the Thursday welcome drinks. Please reach out if you have questions!
          </p>
        </div>

        <div className="mb-8">
          <h2 className="font-display font-bold text-foreground mb-3">Will dietary restrictions be accommodated?</h2>
          <p className="font-body text-muted-foreground leading-relaxed">
            Absolutely! Please indicate any dietary restrictions on your RSVP, and our caterer will accommodate your needs.
          </p>
        </div>
      </article>

      <img src={footerBg} alt="" className="w-full" />
    </div>
  );
}
